import React from 'react'
import "./partnerships.scss"
import Partners from './partners'
import SectionPartnerships from './sectionPartnerships'
import Letsgo from '../connectors/letsgo'



function Partnerships() {
  return (
    <div className='container-partnerships'>
      <div className='section-partnerships'>
        <SectionPartnerships />
      </div>
      <div className='section-partners'>
        <Partners />
      </div>
      <div className='section-lets-go-free'>
        <Letsgo />
      </div>
    </div>
  )
}

export default Partnerships